import React from "react";
import { BoldCaption, InfoCaption } from "../Components";
import { getTranslateByScope } from "../i18n";

const translate = getTranslateByScope("app.customerSelectItem");

export const CustomerSelectItem = (customer) => {
  const name = customer.Name || "";
  const customerNumber = `${translate("kd")}: ${customer.CustomerNo__c} - `;
  const address = [
    customer.BillingStreet,
    `${customer.BillingPostalCode} ${customer.BillingCity}`,
    customer.BillingCountry,
  ]
    .filter((x) => x != null)
    .join(", ");

  return (
    <>
      <div>
        <BoldCaption>
          {name}
          {customer.Blocked__c > 0 && (
            <span
              style={{
                fontWeight: "normal",
                fontSize: "0.7rem",
                fontStyle: "italic",
              }}
            >
              - {customer.Customer_No_blocked_Text__c}
            </span>
          )}
        </BoldCaption>
      </div>
      <InfoCaption>
        {customerNumber}
        {address}
      </InfoCaption>
    </>
  );
};

export default CustomerSelectItem;
